import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { isDevHost } from "@/lib/publicUrl";

const isLiveHost = () => !isDevHost();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Clickjacking guard: the live site never renders inside another website's frame.
// Preview/local stay frameable so the editor preview keeps working.
const framed = (() => { try { return window.top !== window.self; } catch { return true; } })();
if (framed && isLiveHost()) {
  try { window.top.location.replace(window.location.href); } catch { /* cross-origin top */ }
  document.getElementById("root").textContent = "CiteQR can't be shown inside another website. Open getciteqr.com directly.";
} else {
  renderApp();
}

function renderApp() {
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
}
